<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <nb-card>
      <nb-card-header class="card-header">Users & Hierarchy</nb-card-header>
      <div class="row">
        <div class="col-md-12 mt-1">
          <div class="col-md-4 mt-1">
            <mat-form-field floatLabel="always">
              <input type="text" class="w-100 headerInputs" placeholder="Name of Company" value={{companyName}} disabled
                matInput>
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field floatLabel="always">
              <input type="text" class="headerInputs" placeholder="Client Key" value={{customerKey}} disabled matInput>
            </mat-form-field>
          </div>
          <div class="col-md-2" *ngIf="subscriptionType">
            <mat-form-field>
              <input type="text" class="headerInputs text-capitalize" placeholder="Customer Classification"
                value={{subscriptionType}} disabled matInput>
            </mat-form-field>
          </div>
        </div>
      </div>
    </nb-card>
    <nb-card>
      <div class="col-md-12 profileDiv">
        <ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
        <form class="form-horizontal" [formGroup]="formProfileDetails">
          <div class="col-md-4">
            <mat-form-field floatLabel="always" class="col-md-6">
              <input type="text" class="w-100" placeholder="First Name" matInput formControlName="CustomerfirstName"
                required>
            </mat-form-field>
            <div
              *ngIf="formProfileDetails.controls.CustomerfirstName.touched && formProfileDetails.controls.CustomerfirstName.errors"
              class="error col-md-6">
              <div *ngIf="formProfileDetails.controls.CustomerfirstName.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  First name is required
                </div>
              </div>
              <div *ngIf="formProfileDetails.controls.CustomerfirstName.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  First name must contain alphabets and must not begin with space
                </div>
              </div>
            </div>
            <mat-form-field floatLabel="always" class="col-md-6">
              <input type="text" class="w-100" placeholder="Last Name" matInput formControlName="CustomerlastName"
                required>
            </mat-form-field>
            <div
              *ngIf="formProfileDetails.controls.CustomerlastName.touched && formProfileDetails.controls.CustomerlastName.errors"
              class="error col-md-6">
              <div *ngIf="formProfileDetails.controls.CustomerlastName.errors.required">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Last name is required
                </div>
              </div>
              <div *ngIf="formProfileDetails.controls.CustomerlastName.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Last name must contain alphabets and must not begin with space
                </div>
              </div>
            </div>
            <mat-form-field floatLabel="always" class="col-md-12">
              <input type="text" class="w-100" placeholder="Title" formControlName="CustomerTitle" matInput>
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-md-12">
              <input type="text" class="w-100" placeholder="Cell Phone" formControlName="CustomerCellPhone" matInput
                name="phone">
            </mat-form-field>
            <div
              *ngIf="formProfileDetails.controls.CustomerCellPhone.touched && formProfileDetails.controls.CustomerCellPhone.errors"
              class="error col-md-12">
              <div *ngIf="formProfileDetails.controls.CustomerCellPhone.errors.pattern">
                <div class="alert custom-alert-danger" role="alert">
                  <span class="sr-only">Error:</span>
                  Cell Phone number should contain 10 digits
                </div>
              </div>
            </div>
            <mat-form-field floatLabel="always" class="col-md-12">
              <input type="text" class="w-100" placeholder="Email" matInput formControlName="CustomerEmail"
                name="email">
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-md-12">
              <mat-select placeholder="View" formControlName="CustomerView">
                <mat-option *ngFor="let rol of RoleDescription;" [value]="rol.userRoleGroupId">
                  {{ rol.userRoleGroupName }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-md-12">
              <input type="text" class="w-100" placeholder="Assigned to" matInput formControlName="CustomerAssignedTo">
            </mat-form-field>
          </div>

          <div class="col-md-8">
            <mat-form-field floatLabel="always" class="col-md-5">
              <input type="text" class="w-100" placeholder="Approval Limit Repairs/Tow" matInput
                formControlName="CustomerApprovalLimitRepairs">
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-md-4">
              <input type="text" class="w-100" placeholder="Approval Limit Tires" matInput
                formControlName="CustomerApprovalTires">
            </mat-form-field>
            <mat-checkbox class="col-md-3 mt-3" formControlName="CustomerIsApprover">Not an Approver</mat-checkbox>

            <mat-form-field floatLabel="always" class="col-md-5">
              <input type="text" class="w-100" [ngxTimepicker]="ApprovalStart" placeholder="Approval Availability Start"
                matInput formControlName="CustomerApprovalStart">
              <ngx-material-timepicker #ApprovalStart></ngx-material-timepicker>
            </mat-form-field>
            <mat-form-field floatLabel="always" class="col-md-4">
              <input type="text" class="w-100" [ngxTimepicker]="ApprovalStop" placeholder="Approval Availability Stop"
                matInput formControlName="CustomerApprovalStop">
              <ngx-material-timepicker #ApprovalStop></ngx-material-timepicker>
            </mat-form-field>
            <mat-checkbox class="col-md-3 mt-3" (change)="setDays()" formControlName="CustomerHourAvailable">24 Hour
              Available</mat-checkbox>
            <div class="mt-1">
              <div class="col-md-8">
                <div class="weekDays-selector mt-1 mb-3">
                  <ng-container
                    *ngFor="let control of formProfileDetails.get('CustomerWeekday')['controls']; let i = index;"
                    [formGroup]="control">
                    <input type="checkbox" [attr.id]="control.controls.id.value" class="weekday"
                      formControlName="checkbox" />
                    <label [attr.for]="control.controls.id.value ">{{control.controls.text.value}}</label>
                  </ng-container>
                </div>
                <mat-form-field floatLabel="always" class="col-md-12 inputsPadding">
                  <mat-select placeholder="Role" formControlName="CustomerRole">
                    <mat-option *ngFor="let rol of CompanyRoleDescription;" [value]="rol.companyRoleKey">
                      {{ rol.roleDescription }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field floatLabel="always" class="col-md-12 inputsPadding">
                  <mat-select placeholder="Time Zone" formControlName="CustomerTimeZone">
                    <mat-option *ngFor="let items of preSignUpTZDetails" [value]="items.Conversion">
                      {{items.TimeZoneTypeName}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field floatLabel="always" class="col-md-12 inputsPadding">
                  <input type="text" class="w-100" placeholder="Username" formControlName="CustomerUserName" matInput>
                </mat-form-field>
                <div class="col-md-6">
                  <mat-form-field floatLabel="always" class="inputsPadding">
                    <input type="password" class="w-100" placeholder="Password" formControlName="CustomerPassword"
                      matInput [(ngModel)]="password">
                  </mat-form-field>
                  <div
                    *ngIf="formProfileDetails.controls.CustomerPassword.touched && formProfileDetails.controls.CustomerPassword.errors"
                    class="error">
                    <div *ngIf="formProfileDetails.controls.CustomerPassword.errors.required">
                      <div class="alert custom-alert-danger" role="alert">
                        <span class="sr-only">Error:</span>
                        Password is required
                      </div>
                    </div>
                    <div *ngIf="formProfileDetails.controls.CustomerPassword.errors.pattern">
                      <div class="alert custom-alert-danger" role="alert">
                        <span class="sr-only">Error:</span>
                        Password must be of 8 character long having
                        at least one upper case ,one lower case ,one digit,one special character from (#?!@$%^&*-.).
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <mat-form-field floatLabel="always" class="inputsPadding">
                    <input type="password" class="w-100" placeholder="Confirm Password"
                      formControlName="Customerconfpassword" matInput [compareEqual]="password">
                  </mat-form-field>
                  <div
                    *ngIf="formProfileDetails.controls.Customerconfpassword.touched && formProfileDetails.controls.Customerconfpassword.errors"
                    class="error">
                    <div *ngIf="formProfileDetails.controls.Customerconfpassword.errors.required">
                      <div class="alert custom-alert-danger" role="alert">
                        <span class="sr-only">Error:</span>
                        Confirm Password is required
                      </div>
                    </div>
                    <div *ngIf="formProfileDetails.controls.Customerconfpassword.errors.compareEqual">
                      <div class="alert custom-alert-danger" role="alert">
                        <span class="sr-only">Error:</span>
                        Password Do Not Match.
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-md-4 p-0">
                <div class="">
                  <br>
                  <div class="container">
                    <div class="row">
                      <div class="col-sm-12 imgUp ml-3">
                        <div class="imagePreview"><img [src]="imgURL" height="185" class="imageP" *ngIf="imgURL"></div>
                        <label class="btn btn-primary mt-4">
                          Change profile picture<input type="file" accept='image/*' #file
                            (change)="preview(file.files, $event)" class="uploadFile img" value="Upload Photo"
                            style="width: 0px;height: 0px;overflow: hidden;">
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <button class="col-md-3 col-lg-2 btn btn-semi-round bgBlue mt-2 mb-1 pull-right"
              (click)="updateCustomerProfile()" [disabled]="formProfileDetails.invalid">
              Update Profile</button>
          </div>
        </form>
      </div>
    </nb-card>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>
